import { render, staticRenderFns } from "./ShowMoreComponent.vue?vue&type=template&id=3dbd0ce7"
import script from "./ShowMoreComponent.vue?vue&type=script&lang=ts"
export * from "./ShowMoreComponent.vue?vue&type=script&lang=ts"
import style0 from "./ShowMoreComponent.vue?vue&type=style&index=0&id=3dbd0ce7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports